/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NfcTokenCreate
 */
export interface NfcTokenCreate {
    /**
     * An admin-provided description of the token. Between 1 and 100 characters.
     * @type {string}
     * @memberof NfcTokenCreate
     */
    description: string;
    /**
     * The user that can log in using this token. Since tokens might be unused temporarily, allow admins to un-assign users and let the token stay in the system until it gets used again.
     * @type {string}
     * @memberof NfcTokenCreate
     */
    userId: string;
    /**
     * The actual token, a hex unique identifier is between 4 bytes to 10 bytes and it should be a colon between each bytes Normalized to lowercase by the backend.
     * @type {string}
     * @memberof NfcTokenCreate
     */
    token: string;
}

/**
 * Check if a given object implements the NfcTokenCreate interface.
 */
export function instanceOfNfcTokenCreate(value: object): value is NfcTokenCreate {
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('token' in value) || value['token'] === undefined) return false;
    return true;
}

export function NfcTokenCreateFromJSON(json: any): NfcTokenCreate {
    return NfcTokenCreateFromJSONTyped(json, false);
}

export function NfcTokenCreateFromJSONTyped(json: any, ignoreDiscriminator: boolean): NfcTokenCreate {
    if (json == null) {
        return json;
    }
    return {
        
        'description': json['description'],
        'userId': json['userId'],
        'token': json['token'],
    };
}

export function NfcTokenCreateToJSON(json: any): NfcTokenCreate {
    return NfcTokenCreateToJSONTyped(json, false);
}

export function NfcTokenCreateToJSONTyped(value?: NfcTokenCreate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'description': value['description'],
        'userId': value['userId'],
        'token': value['token'],
    };
}

